import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import { INDEX_PATH } from '../../constant'
import styles from './style.module.less'

export default class extends Component {
  render() {
    return (
      <HeaderView contentStyle={{ padding: 0 }}>
        <div className={styles.wrap}>
          <div className={styles.title}>
            <img src="https://qnm.hunliji.com/o_1cnoei4p315g66le185kq16r69.jpg" />
          </div>

          <div className={styles.grey}>
            <img src="https://qnm.hunliji.com/o_1cnofdj3edjv17nc1t2s37c4num.jpg" />
          </div>

          <div>
            <img src="https://qnm.hunliji.com/o_1cnofdj3esdioknf9i488vupn.jpg" />
            <img src="https://qnm.hunliji.com/o_1cnofdj3e1m6vh36k1q12h0jn5o.jpg" />
            <img src="https://qnm.hunliji.com/o_1cnofdj3ei8lm2v11h0regaiip.jpg" />
            <img src="https://qnm.hunliji.com/o_1cnofdj3e1d7lf6017i71d5b1k83q.jpg" />
            <img src="https://qnm.hunliji.com/o_1cnofdj3eu1l8fg1hsu1hrg1jipr.jpg" />
          </div>

          <div className={styles.grey}>
            <img src="https://qnm.hunliji.com/o_1cnofdj3e1fe1293g981j97fits.jpg" />
          </div>

          <div>
            <img src="https://qnm.hunliji.com/o_1cnogaelnsar136s1d20dsa1st91r.jpg" />
          </div>

          <div className={styles.grey} style={{ paddingBottom: 100 }}>
            <img src="https://qnm.hunliji.com/o_1cnofdj3ei6t1crd5qbfnsnhtu.jpg" />
            <div style={{ marginTop: 110 }}>
              <Link to={INDEX_PATH}>
                <img src="https://qnm.hunliji.com/o_1cnogdr0ahc79bifoq1bnq1cpj20.jpg" />
              </Link>
            </div>
          </div>
        </div>
      </HeaderView>
    )
  }
}
